/**
 * GENERATE timestamp of form YYMMDDHHMMSS representing "now"
 * @returns string
 */
export function nowTimestamp () : string {
    let d = new Date()
    const pad2 = n => n.toString().padStart(2,'0')
    return pad2(d.getFullYear() % 100) +
           pad2(d.getMonth() + 1) +
           pad2(d.getDate()) +
           pad2(d.getHours()) +
           pad2(d.getMinutes()) +
           pad2(d.getSeconds())
}


export class DateTime {
    static now () : string {
        return nowTimestamp()
    }
}